export default {
    state: {
        breadcrumbs: [],
    },
    mutations: {
        // this sets the whole breadcrumbs
        set(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs;
        },
        // when navigating to a nested route, you'll use push to add a breadcrumb to the existing breadcrumb
        // it also checks if the route already exists in the breadcrumb by checking the name AND the text
        push(state, route) {
            const index = state.breadcrumbs.findIndex(breadcrumb => breadcrumb.name === route.name && breadcrumb.text === route.text);

            if (index === -1) {
                state.breadcrumbs.push(route);
            }
        },
        // remove the last entry in the breadcrumbs
        pop(state) {
            state.breadcrumbs.pop();
        },
        // empty the breadcrumbs
        empty(state) {
            state.breadcrumbs = [];
        },
    },
    actions: {
        setBreadcrumbs({ commit }, breadcrumbs) {
            commit('set', breadcrumbs);
        },
        pushBreadcrumb({ commit }, route) {
            commit('push', route);
        },
        popBreadcrumb({ commit }) {
            commit('pop');
        },
        emptyBreadcrumbs({ commit }) {
            commit('empty');
        },
    },
    getters: {
        breadcrumbs: state => state.breadcrumbs,
    },
};
